// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__7dIj9","main-credit":"Footer_main-credit__3IjEE","attribution":"Footer_attribution__16IXA"};